<template>
  <div class="tw:flex tw:flex-col tw:gap-10 tw:max-w-3xl tw:mx-auto">
    <div class="tw:flex tw:flex-col tw:gap-2">
      <TextPlay text="ImagePickerPlay — Showcase" size="3xl" weight="bold" color="var(--fontcolor)" />
      <TextPlay text="Upload component with dashed border, media modal integration, and validation states." size="sm" color="var(--text-color)" />
    </div>

    <!-- Default -->
    <section class="tw:flex tw:flex-col tw:gap-3">
      <TextPlay text="1. Default (empty)" size="xl" weight="semibold" color="var(--fontcolor)" />
      <ImagePickerPlay @select="onSelect" @remove="image1 = null" />
    </section>

    <!-- With image selected -->
    <section class="tw:flex tw:flex-col tw:gap-3">
      <TextPlay text="2. With image selected" size="xl" weight="semibold" color="var(--fontcolor)" />
      <ImagePickerPlay
        :src="image2"
        @select="(m) => image2 = m.url"
        @remove="image2 = null"
      />
    </section>

    <!-- Custom height -->
    <section class="tw:flex tw:flex-col tw:gap-3">
      <TextPlay text="3. Custom height (240px)" size="xl" weight="semibold" color="var(--fontcolor)" />
      <ImagePickerPlay h="240px" placeholder="Clique para adicionar uma capa" @select="onSelect" />
    </section>

    <!-- Custom width -->
    <section class="tw:flex tw:flex-col tw:gap-3">
      <TextPlay text="4. Custom width (300px)" size="xl" weight="semibold" color="var(--fontcolor)" />
      <ImagePickerPlay w="300px" h="200px" @select="onSelect" />
    </section>

    <!-- Error state -->
    <section class="tw:flex tw:flex-col tw:gap-3">
      <TextPlay text="5. Error state (validation failed)" size="xl" weight="semibold" color="var(--fontcolor)" />
      <ImagePickerPlay error placeholder="Campo obrigatório" @select="onSelect" />
      <TextPlay text="A capa é obrigatória" size="xs" color="var(--feedback-error-500)" />
    </section>

    <!-- Disabled -->
    <section class="tw:flex tw:flex-col tw:gap-3">
      <TextPlay text="6. Disabled" size="xl" weight="semibold" color="var(--fontcolor)" />
      <ImagePickerPlay disabled placeholder="Não disponível" />
    </section>

    <!-- Disabled with image -->
    <section class="tw:flex tw:flex-col tw:gap-3">
      <TextPlay text="7. Disabled with image (no remove button)" size="xl" weight="semibold" color="var(--fontcolor)" />
      <ImagePickerPlay
        :src="image2"
        disabled
      />
    </section>

    <!-- Skeleton -->
    <section class="tw:flex tw:flex-col tw:gap-3">
      <TextPlay text="8. Skeleton loading" size="xl" weight="semibold" color="var(--fontcolor)" />
      <ImagePickerPlay skeleton />
    </section>

    <!-- Different types -->
    <section class="tw:flex tw:flex-col tw:gap-3">
      <TextPlay text="9. Different media types" size="xl" weight="semibold" color="var(--fontcolor)" />
      <div class="tw:flex tw:gap-4">
        <ImagePickerPlay w="200px" h="120px" type="image" icon="add_photo_alternate" placeholder="Imagem" @select="onSelect" />
        <ImagePickerPlay w="200px" h="120px" type="video" icon="videocam" placeholder="Vídeo" @select="onSelect" />
        <ImagePickerPlay w="200px" h="120px" type="document" icon="note_add" placeholder="Documento" @select="onSelect" />
      </div>
    </section>

    <!-- With FieldPlay -->
    <section class="tw:flex tw:flex-col tw:gap-3">
      <TextPlay text="10. Inside FieldPlay (label + description)" size="xl" weight="semibold" color="var(--fontcolor)" />
      <FieldPlay label="Capa do curso *" description="Tamanho recomendado: 528x710px ou proporcional.">
        <ImagePickerPlay
          :src="image3"
          h="200px"
          :error="showError && !image3"
          @select="(m) => image3 = m.url"
          @remove="image3 = null"
        />
        <TextPlay v-if="showError && !image3" text="A capa é obrigatória" size="xs" color="var(--feedback-error-500)" />
      </FieldPlay>
      <ButtonPlayV2 variant="outline" :text="showError ? 'Limpar erro' : 'Simular validação'" @click="showError = !showError" />
    </section>

    <!-- Cover fit (banners) -->
    <section class="tw:flex tw:flex-col tw:gap-3">
      <TextPlay text="11. fit=&quot;cover&quot; (banner style)" size="xl" weight="semibold" color="var(--fontcolor)" />
      <ImagePickerPlay
        :src="image2"
        h="91px"
        fit="cover"
        @select="(m) => image2 = m.url"
        @remove="image2 = null"
      />
    </section>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { ImagePickerPlay, FieldPlay } from "@/components/atomic"


const image1 = ref<string | null>(null)
const image2 = ref<string | null>('https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&h=300&fit=crop')
const image3 = ref<string | null>(null)
const showError = ref(false)

function onSelect(media: { url: string }) {
  image1.value = media.url
}
</script>
